import http from "../../http-common";

export default class {
  postUserCreate(userInfo: {id: string, email: string, firstName: string, lastName: string, gender: string}) {
    let url = `/impexium/create-user`;

    return http.post(url, userInfo);
  }
}